<template>
	<v-container class="pa-1">

    <v-snackbar v-model="alerta.activo" multi-line :vertical="true" top right :color="alerta.color" > 
      <strong> {{alerta.texto}} </strong>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text @click="alerta.activo = false" v-bind="attrs"> Cerrar </v-btn>
      </template>
    </v-snackbar>

    <v-card-actions>
      <div class="font-weight-black text-md-h6 text-xs-subtitle-1 "> Retener Pedido   </div>
      <v-spacer></v-spacer>
      <v-btn color="error" fab small elevation="1" @click="$emit('modal',false)" ><v-icon>clear</v-icon></v-btn>
    </v-card-actions>

    <!-- <v-container style="height: 300px;" v-if="Loading">
      <loading/>
    </v-container> -->

      <v-row>
        <v-col cols="12">
          <strong>¿Cual es la causa de la retención ? </strong>
          <v-textarea
            outlined
            v-model="obs_retenido " 
            label="Comentarios"	
            rows="3"  
            placeholder="Escribe aquí la causa de la retención..."
            class="mt-2" >
          ></v-textarea>
        </v-col>
      </v-row>

      <div class="mt-6"></div>

      <v-footer absolute >
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="modalValidarRetención = true"> Retener Pedido </v-btn>
      </v-footer>
      
    
    <v-dialog v-model="modalValidarRetención" persistent width="500">
        <v-card>
          <v-card-title class="subtitle-1 font-weight-black " style="word-break:normal;">¿ESTÁS SEGURO DE QUERER RETENER EL PEDIDO ? </v-card-title>
          <v-divider class="my-0 py-3" ></v-divider>
          <v-card-subtitle align="center" class="red--text font-weight-bold "> UNA VEZ ATENDIDA NO PODRÁ EDITARSE </v-card-subtitle>
          <v-divider class="my-0 py-2 " ></v-divider>
          <v-card-actions>
            <v-btn color="error" dark @click="modalValidarRetención=false" >  NO, Cancelar </v-btn>
            <v-spacer/>
            <v-btn color="primary" text @click="asignarPedidoAMaquilador()" >  SÍ, Retener </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

		<overlay v-if="overlay"/>
  </v-container>
</template>

<script>
  import  metodos from '@/mixins/metodos.js';
	import {mapGetters, mapActions} from 'vuex'
  // import loading from '@/components/loading.vue'
  import overlay from '@/components/overlay.vue'

  export default {
    mixins:[metodos],
	  components: {
			// loading,
      overlay
		},
		props:[
			'parametros',
	  ],

    data(){
      return{
        // Loading: false,

        ObjectDefault:{},
        alerta: { activo: false, texto:'', color:'error' },
        overlay: false,

        bodegas:[],
        bodega:{idbodegas:null, nombre:''},
        maquiladores: [],
        maquilador:{ id: null, nombre:'' },
        obs_retenido : '',

        modalValidarRetención: false, 

      }
    },

    created(){
				this.initialize();
		},

    watch:{
			parametros(){
				this.initialize();
			},
    },
			
		computed:{
			// IMPORTANDO USO DE VUEX - CLIENTES (GETTERS)
      ...mapGetters('Login',['getusuarioFetish']),
		},

    watch: {
    },

    methods:{
      
      async initialize(){
        this.limpiarCampos();
      },

      asignarPedidoAMaquilador() {

        this.modalValidarRetención = false;

        if(this.obs_retenido == ''){
          this.alerta = { activo: true, color:'error', texto: "Escriba la causa de la retención del pedido."}
          return;
        }

        this.overlay = true;
        
        const payload = {
          idpedidos: this.parametros.iddocum,
          obs : this.obs_retenido
        }

        this.$http.post('retener.pedido', payload).then( response =>{
          var that = this;
          this.alerta = { activo: true, color:'success', texto: "Pedido retenido correctamente" };
          setTimeout(() => { that.$emit('modal') }, 1000);
          this.finalizarProceso()
        }).catch( error =>{
          console.log('error', error);
          this.alerta = { activo: true, color:'error', texto: error.message };
        }).finally(()=>{ 
          this.overlay = false
        })

      },

      limpiarCampos(){
        this.obs_retenido = '';
      }

    } 

  }
</script>